module.exports = __webpack_public_path__ + "87c323343f75bcf60f45b48d5b111718.svg";